export const EDIT_EVENT_CONSTANT_REQUEST='EDIT_EVENT_CONSTANT_REQUEST'
export const EDIT_EVENT_CONSTANT_SUCCESS='EDIT_EVENT_CONSTANT_SUCCESS'
export const EDIT_EVENT_CONSTANT_FAILURE='EDIT_EVENT_CONSTANT_FAILURE'